import { render, staticRenderFns } from "./QuinielaEquipos.vue?vue&type=template&id=05069b7c&lang=pug"
import script from "./QuinielaEquipos.vue?vue&type=script&lang=js"
export * from "./QuinielaEquipos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports